import { Treasury } from 'common/models/treasury';
import React, { PropsWithChildren } from 'react';
import Tooltip from './Tooltip/Tooltip';
import { TooltipWrapper } from './Tooltip/tooltip.style';
import { useWalletClient } from 'wagmi';
import useSelectedChain from 'hooks/useSelectedChain';

type Props = {
  treasury: Treasury;
};

const AddToWallet: React.FC<Props & PropsWithChildren> = (props) => {
  const { chainId } = useSelectedChain();
  const { data: walletClient } = useWalletClient({ chainId });

  const tokenAddress = props.treasury.address;
  // we only use it for oneTokens which have 18 decimals. Could be changed if needed
  const tokenDecimals = 18;
  const tokenSymbol = props.treasury.displayName;

  const onClick = async (event: React.MouseEvent<HTMLImageElement>) => {
    event.preventDefault();
    const isAddToWalletAvailable = !!walletClient?.request;

    if (!tokenSymbol || !tokenAddress || !tokenDecimals) {
      console.warn("Couldn't resolve token, can't add to wallet.");
      return;
    }

    if (!isAddToWalletAvailable) {
      console.warn("Couldn't resolve function to add to wallet");
      return;
    }

    try {
      await walletClient.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: tokenDecimals,
            // TODO: We currently have no public URLs for these oneTokens so can't link to those here
            image: '',
          },
        },
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="inline-flex">
      {props.children}
      <TooltipWrapper>
        <Tooltip
          message={`Add ${tokenSymbol} to wallet`}
          position="right"
          bubbleSize={{ width: '150px' }}
        >
          <img
            className="icon-plus cursor-pointer"
            onClick={(ev: React.MouseEvent<HTMLImageElement>) => {
              void onClick(ev);
            }}
            alt={`Add ${tokenSymbol} to wallet`}
          />
        </Tooltip>
      </TooltipWrapper>
    </div>
  );
};

export default AddToWallet;
